import SimpleHeader from '../../components/SimpleHeader/SimpleHeader.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import ApplyForm from './ApplyForm.jsx';
import styles from './ApplyPage.module.css';

/**
 * 본부 지원하기 페이지.
 * 구성: 진행절차 안내 → 지원 신청서(구글폼 연결).
 */
export default function ApplyPage() {
  return (
    <>
      <SimpleHeader />

      <main className={styles.main}>
        <div className="wrap">
          <span className={styles.eyebrow}>HQ Application</span>
          <h1 className={styles.title}>
            본부 <span className={styles.hl}>지원하기</span>
          </h1>
          <p className={styles.sub}>
            잉글리시팝과 함께할 지역 본부(파트너)를 모십니다.
            <br />
            신청해 주시면 가맹 상담 직원이 확인 후 바로 연락드립니다.
          </p>

          <p className={styles.stepTitle}>진행절차</p>
          <div className={styles.processTrack}>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 01</span>
              <h4>서류심사</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 02</span>
              <h4>실무면접</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 03</span>
              <h4>임원면접</h4>
            </div>
            <span className={styles.processArrow}>▶</span>
            <div className={styles.processStep}>
              <span className={styles.stNum}>STEP 04</span>
              <h4>최종합격</h4>
            </div>
          </div>
        </div>
        {/* /.wrap(본문) — 아래 신청서는 process.html처럼 풀블리드 회색 섹션으로 분리 */}

        {/* 본부 지원 신청서 — 예전에는 구글폼으로 외부 이동시켰지만, 지금은 이름/연락처/
             이메일/1·2차 희망지역/본부지원 내용 + 개인정보 수집 동의를 사이트 안에서 바로
             입력받는 ApplyForm으로 대체했다(하단 왼쪽 "이전 화면", 오른쪽 "신청하기").
             process-track과의 시각적 구분 + 흰 카드 대비를 위해 회색 배경 풀블리드 섹션으로 분리. */}
        <section className={styles.inquiry} id="apply">
          <div className="wrap">
            <div className={styles.inquiryCard}>
              <h2>본부 지원 신청서</h2>
              <div className={styles.inquiryRule}></div>
              <p className={styles.inquirySub}>아래 정보를 입력해 주시면, 담당자가 확인 후 바로 연락 드립니다.</p>
              <ApplyForm />
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
